<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    style="background: #eee;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn" >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items class="toolbar-items">
      <v-flex
        v-if="isLoggedIn"
        align-center
        layout
        py-2>
        <!-- <v-text-field
          v-if="responsiveInput"
          class="mr-4 mt-2 purple-input"
          label="Search..."
          hide-details
          color="purple"
        /> -->
        <busie-search-input v-if="responsiveInput" class="mr-6 mt-2"/>
        <router-link
          v-ripple
          class="toolbar-items"
          to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>
        <v-badge
          color="error"
          overlap>
          <template
            v-if="notifications.length > 0"
            slot="badge">
            {{ notifications.length }}
          </template>
          <v-menu
            bottom
            left
            content-class="dropdown-menu"
            offset-y
            transition="slide-y-transition">
            <v-icon
              v-ripple
              slot="activator"
              color="tertiary">mdi-bell</v-icon>
            <v-card>
              <v-list dense>
                <v-list-tile
                  v-for="(notification, index) in notifications"
                  :key="index"
                  @click="removeNotification">
                  <router-link
                    v-ripple
                    :to="notification.link">
                    <v-list-tile-title v-text="notification.message"/>
                  </router-link>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
        </v-badge>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <v-icon
            v-ripple
            slot="activator"
            color="tertiary"
            class="toolbar-items">mdi-account</v-icon>
          <v-card>
            <v-list dense>
              <!-- <router-link to="/user-profile">
                <v-list-tile>
                  <v-list-tile-title>
                    View Profile
                  </v-list-tile-title>
                </v-list-tile>
              </router-link> -->
              <change-password :width="500" color="secondary">
                <template #activator=" { on } ">
                  <v-list-tile v-on="on">
                    <v-list-tile-title>
                      Change Password
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </change-password>
              <router-link to="/logout">
                <v-list-tile>
                  <v-list-tile-title>
                    Logout
                  </v-list-tile-title>
                </v-list-tile>
              </router-link>
            </v-list>
          </v-card>
        </v-menu>
        </router-link>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import {
  mapMutations,
  mapGetters,
  mapActions
} from 'vuex'

import SearchInput from '../busie/SearchInput'
import ChangePasswordDialog from '@/components/busie/ChangePasswordDialog'
export default {
  components: {
    'busie-search-input': SearchInput,
    'change-password': ChangePasswordDialog
  },
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    '$route': function (to, from) {
      this.title = to.name
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    // this.initNotifications()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  computed: {
    ...mapGetters('app', { notifications: 'getNotifications' }),
    ...mapGetters('auth', ['isLoggedIn']),
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    ...mapActions('app', ['removeNotification', 'raiseError']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
